import { call, put, takeEvery } from "redux-saga/effects"
import { TYPE_LOAD, TYPE_SAVE, TYPE_DELETE } from "./actionTypes"
import { typeError, loadTypesSuccess, saveTypeSuccess, deleteType } from "./actions"
import service from "../../../api/type.service"

function* findTypes(concept) {
  try {
    const response = yield call(service.getTypes, concept.payload)
    yield put(loadTypesSuccess(response.data))
  } catch (error) {
    yield put(typeError(error.message))
  }
}

function* saveType({ payload: { type } }) {
  try {
    const response =
      !type.id
        ? yield call(service.save, type)
        : yield call(service.update, type)
    //errores de la llamada al servicio    
    const error = response?.response?.data?.error
    if (error) {
      yield put(typeError(error))
    } else {
      yield put(saveTypeSuccess(response?.data))
    }

  } catch (error) {
    yield put(typeError(error))
  }
}
function* deleteTypes(ls) {
  try {
    const data = ls.payload;
    const response =
      yield call(service.disable,
        data.rows, data.createdBy)
    const error = response?.response?.data?.error

    if (error)
      yield put(typeError(error))
    else {
      yield put(deleteType(response?.data))
    }

  } catch (error) {
    yield put(typeError(error))
  }
}


function* typeSaga() {
  yield takeEvery(TYPE_LOAD, findTypes)
  yield takeEvery(TYPE_SAVE, saveType)
  yield takeEvery(TYPE_DELETE, deleteTypes)
}

export default typeSaga
